import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getAccessToken } from '@oliasoft/pkce';
import ClientConfig from '~client/config';
import resolveErrors, { TApiErrorData } from './errorResolver';
import { loadLocalStoreData } from '../services/local-storage.service';

const baseURL = '/adm/api';

const httpClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Language': loadLocalStoreData('locales', 'en'),
  },
});

const requestHandler = (axiosConfig: InternalAxiosRequestConfig) => {
  let token: string | null = null;
  if (!ClientConfig.config.pkce.provider) {
    token = 'NO_PKCE_ACCESS_TOKEN_YET';
  } else {
    token = getAccessToken(
      ClientConfig.config.pkce.provider,
      ClientConfig.config.clientId,
      ClientConfig.config.idpServerUrl,
    );
  }

  if (token) {
    axiosConfig.headers.Authorization = `Bearer ${token}`;
  }
  return axiosConfig;
};

const successHandler = (response: AxiosResponse) => response;

const errorHandler = (error: AxiosError<TApiErrorData>) => {
  if (error.response) {
    resolveErrors(error.response.status, error.response.data);
  }
  return Promise.reject(error);
};

httpClient.interceptors.request.use(requestHandler);

httpClient.interceptors.response.use(successHandler, errorHandler);

export default httpClient;
